module.exports = __webpack_public_path__ + "img/inc.a3b0366f.svg";